import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Image from '../../image/rob.png';
import IntlMessages from '../../components/utility/intlMessages';
import FetchHelper from '../../helpers/fetchHelper';
import FiveZeroZeroStyleWrapper from './500.style';
import Snake from './Snake';
const internalIp = require('internal-ip');
async function getIp(){
  try {
    return await internalIp.v4();
  } catch (e) {
    return null
  }
}
export default class extends Component {

  componentDidMount(){
    this.retrieveData()
  }
  retrieveData = async() => {
    /*FetchHelper.httpRequest('GET', 'user').then(result => {
      if (result.error) {
      } else {
        //this.goBack();
      }
    });*/
  }
  goBack = () => {
    if (window &&  window.location.href) {
       window.location.href = "dashboard"
    }
  }
  render() {
    return (
      <FiveZeroZeroStyleWrapper className="iso500Page">
        <div className="iso500Content">
          <h1>
            <IntlMessages id="page500.title" />
          </h1>
          <h3>
            <IntlMessages id="page500.subTitle" />
          </h3>
          <p>
            <IntlMessages id="page500.description" />
          </p>
          <button type="button" onClick={this.goBack}>
              <IntlMessages id="page500.backButton" />
          </button>


        </div>

        <div className="iso500Artwork">
          <Snake className="snake" size={350}/>
        </div>
      </FiveZeroZeroStyleWrapper>
    );
  }
}
